import { FaTrash } from "react-icons/fa";

const IngredientField = ({
  index,
  value,
  handleChange,
  handleDelete,
  ingredientList,
}) => {
  return (
    <div className='d-flex align-items-center'>
      <input
        value={value}
        type='text'
        className='form-control my-1'
        placeholder=''
        name='emailaddress'
        onChange={(e) => handleChange(e, index)}
      />
      <button
        disabled={ingredientList.length < 2 ? true : false}
        onClick={() => handleDelete(index)}
        className='ml-2 ingredient-field-trash-icon'
      >
        <FaTrash />
      </button>
    </div>
  );
};

export default IngredientField;
